<div mat-dialog-content>
  <div class="row">
    <div class="col-md-12 text-center">
      <gs-icon type="WARN"></gs-icon>
      <div class="confirm">Are you sure?</div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 body text-center">
      <div>{{ scope.message }}</div>
      <small class="caption" *ngIf="scope.caption">
        {{ scope.caption }}
      </small>
    </div>
  </div>
</div>

<div mat-dialog-actions class="mt-20">
  <div class="button-set text-center">
    <button
      mat-stroked-button
      type="button"
      [mat-dialog-close]="false"
      tabindex="-1">
      cancel
    </button>
    <button mat-stroked-button type="button" (click)="onSubmit()" tabindex="-1">
      ok
    </button>
  </div>
</div>
